/**
 * 「团队共享」开关。打开后同企业的人打开插件就能看到这套模板并一起改。
 *
 * 只有共享它的人能关掉：别人关掉等于把它从共享者那里拿走，说不通。
 * 拿不到企业标识（独立页里没带、SDK 不支持）时整个开关不显示，不留一个
 * 点了没反应的按钮。
 */
import { Switch, Tag, Tooltip } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { getAccountId, getTenant, markUnshared } from '../../store/cloudSync';
import type { ContractTemplate } from '../../contract/types';

interface Props {
  template: ContractTemplate;
  onUpdate: (patch: Partial<Pick<ContractTemplate, 'shared' | 'sharedBy'>>) => void;
  compact?: boolean;
}

export function ShareToggle({ template, onUpdate, compact }: Props) {
  const tenant = getTenant();
  const me = getAccountId();
  if (!tenant || !me) return null;
  const byOther = !!template.shared && !!template.sharedBy && template.sharedBy !== me;
  if (byOther) {
    return (
      <Tooltip title="同事共享的团队模板：大家看到的是同一份，改动会同步给所有人">
        <Tag icon={<TeamOutlined />} color="blue" style={{ margin: 0 }}>
          团队模板
        </Tag>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={template.shared ? '已共享给同企业的人；关掉后只有你能看到' : '共享给同企业的人，一人做版式全员可用'}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--ink-2)' }}>
        <Switch
          size="small"
          checked={!!template.shared}
          onChange={(on) => {
            if (on) onUpdate({ shared: true, sharedBy: me });
            else {
              markUnshared(template.id);
              onUpdate({ shared: false });
            }
          }}
        />
        {!compact && (
          <span>
            <TeamOutlined /> 团队共享
          </span>
        )}
      </span>
    </Tooltip>
  );
}
